var render = function () {
  var _vm$festa, _vm$festa$section, _vm$festa$section$txt;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "dark-theme",
    scopedSlots: _vm._u([{
      key: "contentsImmersive",
      fn: function fn() {
        return [_c('v-container', [_c('education-tabs')], 1)];
      },
      proxy: true
    }, {
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "교육 · 법률지원",
            "src": "/images/sub/sub-visual-education.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--sm page-section--first",
    attrs: {
      "title": "법률 지원하기"
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa = _vm.festa) === null || _vm$festa === void 0 ? void 0 : (_vm$festa$section = _vm$festa.section2) === null || _vm$festa$section === void 0 ? void 0 : (_vm$festa$section$txt = _vm$festa$section.txt[0]) === null || _vm$festa$section$txt === void 0 ? void 0 : _vm$festa$section$txt.replace(/\n/g, '<br/>'))
    }
  })]), [_c('table-primary', {
    staticClass: "mb--primary"
  }, _vm._l(_vm.festa.section3.table.list, function (item, index) {
    return _c('table-primary-row', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('span', {
            domProps: {
              "innerHTML": _vm._s(item.title.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }, {
        key: "text",
        fn: function fn() {
          return [_c('p', {
            domProps: {
              "innerHTML": _vm._s(item.input.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1), _c('v-card', {
    staticClass: "mb--md",
    attrs: {
      "outlined": "",
      "color": "grey lighten-3",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "d-none d-md-block pa-md-30px pa-lg-60px"
  }, [_c('h4', {
    staticClass: "tit tit--xs text-center mb-20px mb-md-40px"
  }, [_vm._v(" 진행 프로세스 ")]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/education/law/law-img.png",
      "aspect-ratio": 1040 / 236,
      "max-width": "1040"
    }
  })], 1), _c('div', {
    staticClass: "pa-20px d-md-none"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/education/law/law-img-mo.png",
      "max-width": "572"
    }
  })], 1)]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-210px justify-space-between",
    attrs: {
      "href": "/file/유통데이터_법률자문_의뢰서.docx",
      "download": "",
      "x-large": "",
      "outlined": "",
      "color": "secondary"
    }
  }, [_vm._v(" 신청서 내려받기(.docx) "), _c('icon-down', {
    staticClass: "icon--size-small ml-12px"
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-210px justify-space-between",
    attrs: {
      "href": "/file/유통데이터_법률자문_의뢰서.hwp",
      "download": "",
      "x-large": "",
      "outlined": "",
      "color": "secondary"
    }
  }, [_vm._v(" 신청서 내려받기(.hwp) "), _c('icon-down', {
    staticClass: "icon--size-small ml-12px"
  })], 1)], 1)], 1)]], 2), _c('page-section', {
    staticClass: "page-section--sm page-section--last",
    attrs: {
      "title": "법률 정보 제공",
      "text": "스타트업이 알아야 할 법률 정보를 제공합니다."
    }
  }, [_c('table-primary', {
    staticClass: "mb--primary",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, _vm._l(_vm.applications, function (application, index) {
    var _application$content;
    return _c('v-card', {
      key: index,
      attrs: {
        "tile": ""
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push("/education/law/" + application._id);
        }
      }
    }, [_c('div', {
      staticClass: "pa-16px pa-md-24px"
    }, [_c('h4', {
      staticClass: "tit tit--xs line-height-15 font-weight-regular text-truncate mb-4px mb-md-10px"
    }, [_vm._v(" " + _vm._s(application === null || application === void 0 ? void 0 : application.subject) + " ")]), _c('p', {
      staticClass: "txt line-height-15 text-truncate-2 mb-12px mb-md-24px",
      domProps: {
        "innerHTML": _vm._s(application === null || application === void 0 ? void 0 : (_application$content = application.content) === null || _application$content === void 0 ? void 0 : _application$content.replace(/\n/g, '<br/>'))
      }
    }), _c('p', {
      staticClass: "txt txt--sm"
    }, [_vm._v(" " + _vm._s(_vm.$dayjs(application === null || application === void 0 ? void 0 : application.createdAt).format("YYYY-MM-DD")) + " · 조회수 " + _vm._s(application === null || application === void 0 ? void 0 : application.viewCount) + " ")])]), _c('v-divider', {
      staticClass: "grye lighten-3"
    })], 1);
  }), 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }